import React from 'react'
import UpdateUserForm from '../../component/form/user/UpdateUserForm'

export default function UpdateUser() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">

                        <UpdateUserForm />
                    </div>
                </div>
            </div>
        </>
    )
}
